import { Reducer } from 'redux';
import { SettingsState, SettingsTypes } from './types';
import { AuthActionTypes } from '../auth';

export const initialState: SettingsState = {
  isSubmitting: false,
  changePasswordFailure: false,
  changePasswordSuccess: false,
  client: null,
  editFailure: false,
  editSuccess: false,
  error: undefined,
  isChangingPassword: false,
  loading: false,
  createMerchantFailure: false,
  createMerchantSuccess: false,
  updateMerchantStatusSuccess: false,
  updateMerchantStatusFailure: false,
  updateMerchantError: '',
  allMerchants: [],
  merchants: [],
  singleError: '',
  merchantError: undefined,
  fxCurrencies: [],
  createFxSuccess: false,
  createFxFailure: false
};

const reducer: Reducer<SettingsState> = (state = initialState, action) => {
  switch (action.type) {
    case SettingsTypes.EDIT_ACCOUNT_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        error: undefined,
        editFailure: false,
        editSuccess: false,
      };
    case SettingsTypes.EDIT_ACCOUNT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        client: action.payload,
        editFailure: false,
        editSuccess: true,
      };
    case SettingsTypes.EDIT_ACCOUNT_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
        editSuccess: false,
        editFailure: true,
      };

    case SettingsTypes.GET_CURRENT_USER:
      return {
        ...state,
        loading: true,
      };
    case SettingsTypes.GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        client: action.payload,
      };
    case SettingsTypes.GET_CURRENT_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SettingsTypes.CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        isChangingPassword: true,
        changePasswordFailure: false,
        changePasswordSuccess: false,
        error: undefined,
      };

    case SettingsTypes.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        isChangingPassword: false,
        changePasswordSuccess: true,
        changePasswordFailure: false,
      };

    case SettingsTypes.CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        isChangingPassword: false,
        error: action.payload,
        changePasswordSuccess: false,
        changePasswordFailure: true,
      };
    case SettingsTypes.UPDATE_MERCHANT_STATUS_REQUEST:
      return {
        ...state,
        isSubmitting: true
      };
    case SettingsTypes.UPDATE_MERCHANT_STATUS_SUCCESS:
      const resp = action.payload
      for (var i = 0; i < state.allMerchants.length; i += 1){
        if (state.allMerchants[i].emailAddress === resp.EmailAddress) {
          state.allMerchants[i].isActive = resp.IsActive
        }
      }
      return {
        ...state,
        isSubmitting: false,
        updateMerchantStatusSuccess: true,
        updateMerchantStatusFailure: false,
        // merchants: [action.payload, ...state.merchants],
      };
    case SettingsTypes.UPDATE_MERCHANT_STATUS_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        updateMerchantError: action.payload,
        updateMerchantStatusFailure: true,
        updateMerchantStatusSuccess: false
      };

    case SettingsTypes.GET_MERCHANTS_REQUEST:
      return {
        ...state,
      }
    case SettingsTypes.GET_MERCHANTS_SUCCESS:
      return {
        ...state,
        allMerchants: action.payload
      }
    case SettingsTypes.GET_MERCHANTS_FAILURE:
      return {
        ...state,
        error: action.payload
      }
    case SettingsTypes.REGISTER_MERCHANT_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        merchantError: undefined,
        singleError: '',
      };
  
    case SettingsTypes.REGISTER_MERCHANT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        createMerchantSuccess: true,
        createMerchantFailure: false,
        merchants: [action.payload, ...state.merchants],
      };

    case SettingsTypes.REGISTER_MERCHANT_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        merchantError: action.payload,
        createMerchantFailure: true,
        createMerchantSuccess: false,
      };

    case SettingsTypes.LOG_SINGLE_ERROR: {
      return {
        ...state,
        isSubmitting: false,
        singleError: action.payload,
        createMerchantSuccess: false,
      };
    }

    case SettingsTypes.CLEAR_SOME_BOOLEANS:
      return {
        ...state,
        changePasswordFailure: false,
        changePasswordSuccess: false,
        editFailure: false,
        editSuccess: false,
        createMerchantFailure: false,
        createMerchantSuccess: false,
        error: undefined,
        merchantError: undefined,
        singleError: '',
        createFxFailure: false,
        createFxSuccess: false
      };
    case SettingsTypes.FX_RATE_SUCCESS:
      return {
        ...state,
        fxCurrencies: action.payload
      }
    case SettingsTypes.ADD_FX_RATE_SUCCESS:
      return {
        ...state,
        createFxSuccess: true,
        createFxFailure: false
      }
    case SettingsTypes.ADD_FX_RATE_FAILURE:
      return {
        ...state,
        createFxSuccess: false,
        createFxFailure: true,
        error: action.payload
      }
    case AuthActionTypes.DESTROY_STATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer as settingsReducer };
